import { ValueOrReason } from '@/components/warehouse/primitives'
import { formatRubleAmount, formatRublePerGram } from '@/lib/market-money'

export type BuyerPriceBasis = 'buyer' | 'ours'

/** One price and its ₽/g, muted when it is our price standing in for an uncollected buyer-side value. */
export function BuyerPriceCell({ amount, unavailableReason, basis, pricePerGram, pricePerGramUnavailableReason, description }: {
  amount: number | null
  unavailableReason: string
  basis: BuyerPriceBasis
  pricePerGram: number | null
  pricePerGramUnavailableReason: string
  description: string
}) {
  if (amount === null) {
    return <span data-storefront-state="unavailable"><ValueOrReason value={null} reason={unavailableReason} /></span>
  }
  const ours = basis === 'ours'
  return (
    <span className="block min-w-[110px]" data-storefront-state="live" data-price-basis={basis} title={description}>
      <span className={`block whitespace-nowrap font-semibold tabular-nums ${ours ? 'text-ink-muted' : 'text-ink'}`} data-price-role="selling-price">
        {formatRubleAmount(amount)}
      </span>
      <span className="mt-0.5 block text-[11px] tabular-nums text-ink-muted" data-price-role="per-gram">
        {pricePerGram === null
          ? <ValueOrReason value={null} reason={pricePerGramUnavailableReason} />
          : formatRublePerGram(pricePerGram)}
      </span>
    </span>
  )
}
